'use strict';

// This file contains the default i18n config which is used prior to the client context being loaded.
module.exports = {
    defaultLocale: 'en-gb',
    fallbackLocale: 'en',
    defaultNumericLocale: 'en',
    displayNegativesInParentheses: true,
};
